import axios from "../services/axios";



export async function getCompanyData({companyId, locationParam, actionParam, sequenceParam, signatureParam}) {
    try {

        const response = await axios.get(`/smartmenu/company/data`, {
            params: {
                companyId: companyId,
                locationParam: locationParam, 
                actionParam: actionParam,
                sequenceParam: sequenceParam,
                signatureParam: signatureParam
            },
        });

        if (response.status === 200) {
            return response.data;
        }

    } catch (error) {
        console.error('ERROR IN GET COMPANY DATA', error);
        throw error;
    }
};